/* ============================================================
   BOOKER — Camada de dados: índices econômicos + utilidades.
   Os contratos/clientes vêm do backend (ver carregarReais).
   ============================================================ */

const HOJE = new Date(); HOJE.setHours(0, 0, 0, 0);

/* ---- Índices econômicos (estrutura; valores atualizados ao vivo pelo Banco Central — ver services/indices.js) ---- */
const INDICES = {
  IGPM: {
    key: 'IGPM', label: 'IGP-M', fonte: 'FGV', color: '#E59230',
    anual: { 2015: 10.54, 2016: 7.19, 2017: -0.53, 2018: 7.55, 2019: 7.30, 2020: 23.14, 2021: 17.78, 2022: 5.45, 2023: -3.18, 2024: 6.54, 2025: -1.04, 2026: 3.18 },
    acum12: 3.18,
  },
  IPCA: {
    key: 'IPCA', label: 'IPCA', fonte: 'IBGE', color: '#3F6FD6',
    anual: { 2015: 10.67, 2016: 6.29, 2017: 2.95, 2018: 3.75, 2019: 4.31, 2020: 4.52, 2021: 10.06, 2022: 5.79, 2023: 4.62, 2024: 4.83, 2025: 4.26, 2026: 4.64 },
    acum12: 4.64,
  },
};

/* Acumulado de um índice entre duas datas (pró-rata mensal por ano-base) */
function indiceAcumulado(indiceKey, from, to) {
  const idx = INDICES[indiceKey];
  if (!idx || to <= from) return 0;
  let fator = 1;
  let cur = new Date(from);
  while (cur < to) {
    const ano = cur.getFullYear();
    const fimAno = new Date(ano + 1, 0, 1);
    const tramo = to < fimAno ? to : fimAno;
    const meses = (tramo.getFullYear() - cur.getFullYear()) * 12 + (tramo.getMonth() - cur.getMonth()) + (tramo.getDate() - cur.getDate()) / 30;
    const taxaAno = (idx.anual[ano] ?? idx.acum12) / 100;
    fator *= Math.pow(1 + taxaAno, meses / 12);
    cur = fimAno;
  }
  return (fator - 1) * 100;
}

/* ---- Utilidades de data/formatação ---- */
// Datas no formato 'YYYY-MM-DD' são interpretadas como LOCAIS (não UTC), senão
// o fuso do Brasil (UTC-3) joga a data para o dia anterior (ex.: 2025-01-01 -> 31/12/2024).
const parseData = (d) => {
  if (d instanceof Date) return new Date(d);
  if (typeof d === 'string') {
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(d);
    if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
  }
  return new Date(d);
};
const fmtData = (d) => parseData(d).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
const fmtDataLonga = (d) => parseData(d).toLocaleDateString('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
const fmtBRL = (v) => v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
const fmtNum = (v, dec = 0) => v.toLocaleString('pt-BR', { minimumFractionDigits: dec, maximumFractionDigits: dec });
const diasAte = (d) => Math.round((parseData(d) - HOJE) / 86400000);
const addMeses = (d, m) => { const x = parseData(d); x.setMonth(x.getMonth() + m); return x; };

/* ---- Dados dos contratos (carregados do backend via carregarReais) ---- */
let CLIENTES = [];
let CONTRATOS = [];
let HISTORICO = [];

/* ---- Helpers de domínio ---- */
function clienteDe(id) { return CLIENTES.find(c => c.id === id); }
function contratosComCliente() {
  return CONTRATOS.map(k => ({ ...k, cliente: clienteDe(k.clienteId), dias: diasAte(k.dataVencimento) }));
}
function janelaRenovacao(k, dias = 30) {
  if (k.status === 'Encerrado') return false;   // encerrado não renova nem alerta
  const d = diasAte(k.dataVencimento);
  return d >= 0 && d <= dias;
}

/* Carrega os contratos reais (clientes + contratos) vindos do backend. */
function carregarReais(clientes, contratos) {
  CLIENTES = clientes || [];
  CONTRATOS = contratos || [];
  HISTORICO = [];
  window.DB.CLIENTES = CLIENTES;
  window.DB.CONTRATOS = CONTRATOS;
  window.DB.HISTORICO = HISTORICO;
}

window.DB = {
  HOJE, INDICES, CLIENTES, CONTRATOS, HISTORICO,
  indiceAcumulado, clienteDe, contratosComCliente, janelaRenovacao, carregarReais,
  fmtData, fmtDataLonga, fmtBRL, fmtNum, diasAte, addMeses, parseData,
};
